var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDjango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "uh2cmy7u6a",
    d: "M0 0.712L476.03 0.712 476.03 432 0 432z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dqmrh3ltfc",
    d: "M0 432.288L476.03 432.288 476.03 1 0 1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.5 58)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7D16F",
    d: "M320.758 141.435h-29.484c-2.786 0-5.044 2.258-5.044 5.044v30.163c0 2.786 2.258 5.043 5.044 5.043h29.484c2.785 0 5.043-2.257 5.043-5.042V146.48c0-2.786-2.258-5.044-5.043-5.044M215.373 236.127v68.952l-1.077.158c-4.837.714-9.765 1.075-14.647 1.076-22.3 0-34.583-12.663-34.583-35.655 0-23.49 12.679-36.978 34.88-37.005.298-.006.597-.008.893-.008 4.651 0 9.245.737 13.669 2.196l.865.286zm39.581-89.86c0-2.786-2.258-5.044-5.044-5.044h-29.493c-2.785 0-5.044 2.258-5.044 5.044v58.84l-1.573-.401c-5.44-1.392-11.046-2.098-16.662-2.098-.438 0-.873.004-1.209.012-21.32 0-39.277 6.487-51.932 18.759-12.632 12.247-19.309 29.559-19.309 50.064 0 21.566 6.517 38.097 19.368 49.13 12.907 11.083 32.269 16.715 57.578 16.74 16.434-.08 32.987-1.644 49.196-4.652 2.391-.444 4.124-2.528 4.124-4.96V146.268zM320.704 197.407h-29.388c-2.785 0-5.043 2.258-5.043 5.043v84.061c0 36.16-1.805 50.188-8.006 62.468l-.065.126c-5.265 9.483-12.948 17.435-22.217 23-1.596.957-2.536 2.717-2.442 4.576.094 1.86 1.203 3.517 2.888 4.31l24.36 11.478c.68.321 1.413.482 2.148.482.706 0 1.412-.148 2.073-.445 13.232-5.962 24.271-16.3 31.085-29.119 7.215-13.62 9.651-29.38 9.651-62.455V202.45c0-2.785-2.258-5.043-5.044-5.043"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .288)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y0ch3tn20b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uh2cmy7u6a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M47.095 17.712C29.938 17.712 17 30.366 17 47.147v338.419C17 401.796 29.169 415 44.126 415h387.779c14.957 0 27.126-13.204 27.126-29.434V47.146c0-16.846-12.754-29.434-24.158-29.434H47.095zM431.905 432H44.125C19.796 432 0 411.17 0 385.566V47.146C0 20.675 20.246.713 47.095.713h387.778c21.925 0 41.158 21.698 41.158 46.435v338.419c0 25.604-19.795 46.434-44.126 46.434z",
    mask: "url(#y0ch3tn20b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "8uxiiyrv2d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dqmrh3ltfc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M4.293 104.788L475.751 104.788 475.751 87.788 4.293 87.788zM142.997 61.03H43.812c-4.97 0-9-4.03-9-9 0-4.972 4.03-9 9-9h99.185c4.971 0 9 4.028 9 9 0 4.97-4.029 9-9 9M310.26 61.03h-18.281c-4.971 0-9-4.03-9-9 0-4.972 4.029-9 9-9h18.28c4.972 0 9 4.028 9 9 0 4.97-4.028 9-9 9M365.932 60.58H347.09c-4.97 0-9-4.029-9-9 0-4.97 4.03-9 9-9h18.842c4.97 0 9 4.03 9 9 0 4.971-4.03 9-9 9M421.8 60.58h-18.842c-4.97 0-9-4.029-9-9 0-4.97 4.03-9 9-9H421.8c4.97 0 9 4.03 9 9 0 4.971-4.03 9-9 9",
    mask: "url(#8uxiiyrv2d)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDjango);
export default __webpack_public_path__ + "static/media/icon--django.ca0026b9b7c40840ef1ea8ebf889c81a.svg";
export { ForwardRef as ReactComponent };